import styled from 'styled-components';
import { grayLight, blackSphera, whiteSphera } from 'src/utilities/UIStyles/variables/Colors';

export const MediaContainer = styled.section`
  background-color: ${grayLight};
`;
export const MediaTitle = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-top: 2%;
  height: 350px;
  > h2 {
    color: ${blackSphera};
    font-size: 2.5vw;
    font-weight: bold;
    padding-right: 5%;
    margin: 10% 0 0 2%;
    width: 35%;
  }
  > img {
    width: 50%;
    height: auto;
    background-size: cover;
    top: 0;
    right: 0;
    position: absolute;
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    width: 100%;
    flex-wrap: wrap;
    > h2 {
      width: 35%;
    }
    > img {
      width: 60%;
    }
  }
  @media (max-width: 600px) {
    padding-top: 20%;
    height: auto;
    > h2 {
      text-align: center;
      font-size: 6vw;
      font-weight: bold;
      width: 100%;
    }
    > img {
      display: none;
    }
  }
`;

export const MediaImgSection = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;
  margin-top: 5%;
  padding-bottom: 5%;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    margin-top: 0;
    padding-bottom: 0;
  }
`;

export const MediaCard = styled.div`
  height: 400px;
  margin: 5%;
  width: 20%;
  background-color: ${whiteSphera};
  border-radius: 10px;
  > figure {
    width: 100%;
    height: 300px;
    margin: auto auto 15% auto;

    > img {
      width: 100%;
      height: 100%;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
  }
  /* > p:nth-child(2) {
    width: 90%;
    margin: auto;
    padding: 5% 0 2% 0;
    font-size:.8vw;
  }
  > h4 {
    width: 60%;
    height: 15%;
    margin-left: 5%;
    padding-bottom: 10%;
    font-size: 1vw;
  }
  > p:nth-child(4) {
    width: 80%;
    height: 15%;
    margin-left: 5%;
    padding-bottom: 15%;
    font-size: .9vw;
  } */
  > a {
    display: block;
    color: ${whiteSphera};
    font-weight: bold;
    font-size: 1.1vw;
    text-decoration: none;
    text-align: center;
    line-height: 40px;
    width: 40%;
    border-radius: 5px;
    background-color: ${blackSphera};
    margin: 1% 30%;
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    width: 40%;
    height: 450px;
    > figure:nth-child(1) {
      > img {
      }
    }
    /* > p:nth-child(2) {
      padding: 5% 0 5% 0;
      font-size:1.5vw;
    }
    > h4 {
      font-size: 1.5vw;
    }
    > p:nth-child(4) {
      font-size: 1.5vw;
    } */
    > a {
      > figure {
        > img {
        }
      }
    }
  }
  @media (max-width: 600px) {
    width: 80%;
    margin-top: 10%;
    > figure:nth-child(1) {
      > img {
      }
    }
    /* > p:nth-child(2) {
      padding: 5% 0 5% 0;
      font-size:3.5vw;
    }
    > h4 {
      font-size: 5vw;
    }
    > p:nth-child(4) {
      font-size: 4vw;
    } */
    > a {
      > figure {
        > img {
        }
      }
    }
  }
`;
export const MediaCardNone = styled.section`
  width: 25.1%;
  height: 400px;
  margin-top: 5%;
  background-color: white;
  @media (min-width: 600px) and (max-width: 1024px) {
  }
  @media (max-width: 600px) {
    height: 0;
  }
`;
